var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"calendar-rooms"},[(_vm.center)?_c('h2',{staticClass:"center-title"},[_vm._v("\n    "+_vm._s(_vm.center.name)+"\n  ")]):_vm._e(),_c('v-date-picker',{staticClass:"calendar",attrs:{"locale":this.$i18n.locale,"color":"red darken-1"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }